import * as storeConst from "./constants";
import { EVENT_TOAST_MESSAGE } from "@/store/events";
import { EventBus } from "@/event-bus";
import { makeCall, handleProgramServiceError } from "@/utils/request";
import { buildOptions, getEndPoints } from "@/utils/api-call";

export const state = {
  pathTemplates: {
    data: [],
    pagination: {
      current_page: 1,
      per_page: 5,
      count: 0,
      total: 0,
      total_pages: 0
    }
  },
  levelPaths: [],
  requiredPath: {}
};

export const getters = {
  [storeConst.GETTERS_LEVEL_PATHS]: state => {
    return state.levelPaths;
  },
  [storeConst.GETTERS_LIST_PATH_TEMPLATES]: state => {
    return state.pathTemplates;
  }
};

export const actions = {
  [storeConst.ACTIONS_SET_LEVEL_PATHS]: ({ commit }, options) => {
    commit(storeConst.MUTATIONS_SET_LEVEL_PATHS, options.data);
    if (options.callback) {
      options.callback();
    }
  },
  [storeConst.ACTIONS_GET_LIST_PATH_TEMPLATES]: ({ commit }, options) => {
    const url = getEndPoints().levelPaths.getAllTemplate;
    if (options.getAll) {
      let employerId = options.params.employerId;
      options.params = {
        limit: 1000,
        employerId: employerId
      }
    }
    makeCall(url, buildOptions("GET", options), commit)
      .then(response => {
        commit(storeConst.MUTATIONS_SET_LIST_PATH_TEMPLATES, response);
        if (options.callback) {
          options.callback(response);
        }
      })
      .catch(function(error) {
        handleProgramServiceError(error);
      });
  },
  [storeConst.ACTIONS_GET_LIST_RAS_PATH_TEMPLATES]: ({ commit }, options) => {
    const url = getEndPoints().levelPaths.getAllRASTemplate;
    makeCall(url, buildOptions("GET", options), commit)
      .then(response => {
        commit(storeConst.MUTATIONS_SET_LIST_PATH_TEMPLATES, response);
        if (options.callback) {
          options.callback();
        }
      })
      .catch(function(error) {
        handleProgramServiceError(error);
      });
  },
  [storeConst.ACTIONS_ADD_PATH_TO_LEVEL]: ({ commit }, options) => {
    const url = getEndPoints().levelPaths.addPathToLevel;
    makeCall(url, buildOptions("POST", options.data), commit).then(response => {
      if (options.successMessage) {
        EventBus.$emit(EVENT_TOAST_MESSAGE, options.successMessage);
      }
      if (options.callback) {
        options.callback(response);
      }
    });
  },
  [storeConst.ACTIONS_DELETE_LEVEL_PATH]: ({ commit }, options) => {
    const url = getEndPoints().levelPaths.delete.replace(":id", options.id);
    makeCall(url, buildOptions("DELETE", {}), commit).then(response => {
      if (options.successMessage) {
        EventBus.$emit(EVENT_TOAST_MESSAGE, options.successMessage);
      }
      if (options.callback) {
        options.callback(response);
      }
    });
  }
};

export const mutations = {
  [storeConst.MUTATIONS_SET_LEVEL_PATHS]: (state, payload) => {
    if (payload) {
      state.levelPaths = payload;
    }
  },
  [storeConst.MUTATIONS_SET_LIST_PATH_TEMPLATES]: (state, payload) => {
    if (payload) {
      state.pathTemplates.data = payload.data;
      state.pathTemplates.pagination = payload.meta.pagination;
    }
  }
};

export default {
  state,
  actions,
  getters,
  mutations
};



// WEBPACK FOOTER //
// ./src/store/modules/basic_paths/index.js